module.exports = __webpack_public_path__ + "img/xpg.18bf1965.png";